import React from 'react';
import { Button } from '../ui/Button';

export function AdminPagination({
  offset,
  limit,
  total,
  loading,
  onOffsetChange,
}) {
  const canPrev = offset > 0;
  const canNext = offset + limit < total;

  return (
    <div className="mt-4 flex items-center justify-between">
      <Button
        variant="outline"
        size="sm"
        disabled={!canPrev || loading}
        onClick={() => onOffsetChange(Math.max(0, offset - limit))}
      >
        ก่อนหน้า
      </Button>
      <span className="text-xs text-gray-500">
        {total === 0 ? '0' : `${offset + 1}–${Math.min(offset + limit, total)}`} /{' '}
        {total}
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={!canNext || loading}
        onClick={() => onOffsetChange(offset + limit)}
      >
        ถัดไป
      </Button>
    </div>
  );
}
